var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFPlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 11.676L19.892 0L0 22.16H21.088L30.5 11.676Z",
    fill: "url(#paint0_linear_8_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6039 33.8401L1.19189 44.3201L11.7999 56.0001L31.6919 33.8401H10.6039Z",
    fill: "url(#paint1_linear_8_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.604 33.8399L20.356 22.9719L21.088 22.1599H0L10.604 33.8399Z",
    fill: "url(#paint2_linear_8_242)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.604 33.8399H31.692L21.088 22.1599L20.356 22.9719L10.604 33.8399Z",
    fill: "url(#paint3_linear_8_242)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_242",
    x1: 25.544,
    y1: 6.356,
    x2: 3.91999,
    y2: 26.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_242",
    x1: 5.9759,
    y1: 49.7401,
    x2: 27.7679,
    y2: 29.6361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55684"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF2D5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_242",
    x1: 5.304,
    y1: 27.9959,
    x2: 17.248,
    y2: 17.4639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0764A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAA4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_242",
    x1: 26.38,
    y1: 28.0079,
    x2: 15.004,
    y2: 38.3479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#911C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF2D5D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFPlogo);
export default __webpack_public_path__ + "static/media/FPlogo.3eec292020471eddfa801de87f9101b4.svg";
export { ForwardRef as ReactComponent };